export default __webpack_public_path__ + "static/media/four.17ee509d.jpeg";